module.exports = __webpack_public_path__ + "img/calcSystemModel.38649966.png";